type CurrencyConfig = {
  locale: string;
  currency: string;
};

const currencyMap: Record<string, CurrencyConfig> = {
  R$: { locale: "pt-BR", currency: "BRL" },
  $: { locale: "en-US", currency: "USD" },
  "€": { locale: "fr-FR", currency: "EUR" },
  BRL: { locale: "pt-BR", currency: "BRL" },
  USD: { locale: "en-US", currency: "USD" },
  EUR: { locale: "fr-FR", currency: "EUR" },
};

export const formatCurrency = (
  value: number | undefined | null,
  symbol: string,
): string => {
  const numericValue = isNaN(Number(value)) ? 0 : Number(value);

  if (!symbol) {
    const cfg = currencyMap["BRL"];
    return numericValue.toLocaleString(cfg.locale, {
      style: "currency",
      currency: cfg.currency,
    });
  }

  const key = String(symbol).trim();
  const upper = key.toUpperCase();

  const config = currencyMap[key] ||
    currencyMap[upper] || { locale: "pt-BR", currency: "BRL" };

  return numericValue.toLocaleString(config.locale, {
    style: "currency",
    currency: config.currency,
  });
};

export const getMaskCurrencyConfig = (symbol: string) => {
  switch (symbol) {
    case "BRL":
      return {
        thousandSeparator: ".",
        decimalSeparator: ",",
        prefix: "R$ ",
      };
    case "USD":
      return {
        thousandSeparator: ",",
        decimalSeparator: ".",
        prefix: "$ ",
      };
    case "EUR":
      return {
        thousandSeparator: ", ",
        decimalSeparator: ",",
        prefix: "€ ",
      };
    default:
      return {
        thousandSeparator: ".",
        decimalSeparator: ",",
        prefix: `${symbol} `,
      };
  }
};
